import styled from 'styled-components'

export const HeaderContainer = styled.div`
  width: 100%;

  h2 {
    margin-bottom: 1rem;
    font-size: 1.5rem;
  }

  p {
    font-size: 0.85rem;
  }
`
